import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { PiSuitcaseRollingDuotone } from 'react-icons/pi';

const SpecialtyDetail = () => {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { specialty } = useParams();

  useEffect(() => {
    const fetchCities = async () => {
      try {
        setLoading(true);
        const response = await fetch(`/api/active-cities-by-specialty/${specialty}`);
        const result = await response.json();
        console.log('Specialty:', specialty);
        console.log('Respuesta del API:', result);
        
        if (!Array.isArray(result)) {
          throw new Error('Formato de respuesta inválido');
        }

        setCities(result);
        console.log('Ciudades recibidas:', result.length);
        setError(null);
      } catch (error) {
        console.error('Error al obtener ciudades:', error);
        setError('Error al cargar las ciudades');
      } finally {
        setLoading(false);
      }
    };

    fetchCities();
  }, [specialty]);

  const groupedCities = useMemo(() => {
    if (!Array.isArray(cities) || cities.length === 0) {
      return {};
    }
    
    return cities.reduce((acc, city) => {
    const firstLetter = city.name.charAt(0).toUpperCase();
    if (!acc[firstLetter]) {
      acc[firstLetter] = [];
    }
    acc[firstLetter].push(city);
    return acc;
  }, {});
  }, [cities]);

  const specialtyName = specialty === 'urologos' ? 'Urólogos' : 
                       specialty === 'pediatras' ? 'Pediatras' : 
                       specialty === 'dermatologos' ? 'Dermatólogos' : 
                       specialty === 'traumatologos' ? 'Traumatólogos' :
                       specialty === 'dentistas' ? 'Dentistas' :
                       specialty === 'otorrinolaringologos' ? 'Otorrinolaringólogos' :
                       specialty === 'nutriologos' ? 'Nutriólogos' :
                       specialty === 'oftalmologos' ? 'Oftalmólogos' :
                       specialty === 'psiquiatras' ? 'Psiquiatras' :
                       specialty === 'cardiologos' ? 'Cardiólogos' :
                       specialty === 'endocrinologos' ? 'Endocrinólogos' :
                       specialty === 'gastroenterologos' ? 'Gastroenterólogos' :
                       specialty === 'cirujanos-plasticos' ? 'Cirujanos Plásticos' :
                       specialty === 'psicologos' ? 'Psicólogos' :
                       specialty === 'podologos' ? 'Podólogos' :
                       specialty === 'acupuntores' ? 'Acupuntores' :
                       specialty === 'reumatologos' ? 'Reumatólogos' :
                       specialty === 'internistas' ? 'Internistas' :
                       specialty === 'angiologos' ? 'Angiologos' :
                       specialty === 'neurologos' ? 'Neurologos' :
                       specialty === 'homeopatas' ? 'Homeopatas' :
                       specialty === 'alergologos' ? 'Alergologos' :
                       specialty === 'fisioterapeutas' ? 'Fisioterapeutas' :
                       specialty === 'laboratorios-de-analisis-clinicos' ? 'Laboratorios de Análisis Clínicos' :
                       specialty === 'nefrologos' ? 'Nefrologos' :
                       specialty === 'proctologos' ? 'Proctologos' :
                       specialty === 'neumologos' ? 'Neumologos' :
                       specialty === 'medicos-familiares' ? 'Medicos Familiares' :
                       specialty === 'spa-terapeuticos' ? 'Spa Terapéuticos' :
                       specialty === 'farmacias' ? 'Farmacias' :
                       specialty === 'audiologos' ? 'Audiologos' :
                       specialty === 'masajistas' ? 'Masajistas' :
                       specialty === 'tiendas-de-articulos-ortopedicos' ? 'Tiendas de Articulos Ortopédicos' :
                       specialty === 'tiendas-de-sillas-de-ruedas' ? 'Tiendas de Sillas de Ruedas' :
                       specialty === 'opticas' ? 'Opticas' :
                       specialty === 'radiologos' ? 'Radiologos' :
                       specialty === 'optometristas' ? 'Optometristas' :
                       specialty === 'quiropractico' ? 'Quiropractico' :
                       specialty === 'periodoncistas' ? 'Periodoncistas' :
                       specialty === 'esteticistas' ? 'Esteticistas' :
                       'Ginecólogos';

  const sortedLetters = Object.keys(groupedCities).sort();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <Helmet>
        <title>{`${specialtyName} por ciudad | Directorio Médico`}</title>
        <meta name="description" content={`Encuentra ${specialtyName.toLowerCase()} en las principales ciudades de México`} />
        <meta name="keywords" content={`${specialtyName}, ciudades, México, directorio médico`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <h1 className="text-3xl font-bold text-gray-900 mb-8">
        {specialtyName} por ciudad
      </h1>

      {loading ? (
        <div className="text-center py-12">Cargando ciudades...</div>
      ) : error ? (
        <div className="text-center py-12 text-red-600">{error}</div>
      ) : cities.length === 0 ? (
        <div className="text-center py-12">No se encontraron ciudades disponibles</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {sortedLetters.map(letter => (
            <div key={letter} className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">{letter}</h2>
              <ul className="space-y-2">
                {groupedCities[letter].map(city => (
                  <li key={`${city.slug}-${city.stateSlug}`}>
                    <a
                      href={`/${city.stateSlug}/${specialty}-en-${city.slug}`}
                      className="text-primary-600 hover:text-primary-800 transition-colors"
                    >
                      {specialtyName} en {city.name}
                      <span className="text-gray-500 text-sm ml-2">({city.state})</span>
                    </a>
                  </li>
                ))}
              </ul>
          </div>
        ))}
      </div>
      )}
    </div>
  );
};

export default SpecialtyDetail; 